/**
 * API de clientes.
 * Endpoints esperados:
 * - GET /api/clientes - lista todos os clientes
 * - POST /api/clientes/sync - sincroniza cliente (upsert por email)
 */

import { apiUrl } from './api';
import type { ClienteRegistro } from './clientesStorage';

export async function fetchClientesFromApi(): Promise<ClienteRegistro[]> {
  try {
    const res = await fetch(apiUrl('/api/clientes'));
    if (!res.ok) return [];
    const data = await res.json();
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
}

export async function syncClienteToApi(cliente: Partial<ClienteRegistro> & { email: string }): Promise<boolean> {
  try {
    const res = await fetch(apiUrl('/api/clientes/sync'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(cliente),
    });
    return res.ok;
  } catch {
    return false;
  }
}
